import type { ExternalTableSchema } from '@packages/table-builder';

export const cashTransferDashboardTable: ExternalTableSchema = {
  metadata: {
    title: 'Cash Transfer Dashboard',
    entity: 'CashTransferDashboard',
  },

  dataSource: {
    endpoint:
      '/api/award-settlement/api/app/participant-cash-transfer-service/cash-transfer-dashboard',
    method: 'GET',
    rowIdField: 'id',
    requestParams: {
      CompanyIds: 'filters.companyIds',
      CashTransferStatusIds: 'filters.cashTransferStatusIds',
    },
    filters: [
      {
        name: 'companyIds',
        placeholder: 'Company',
        type: 'asyncSelect',
        multiple: true,
        dataSource: {
          url: '/api/customer/api/app/participant-broker-account/company-list',
          labelField: 'companyName',
          valueField: 'id',
        },
      },
      {
        name: 'cashTransferStatusIds',
        placeholder: 'Transfer Status',
        type: 'asyncSelect',
        multiple: true,
        dataSource: {
          url: '/api/award-settlement/api/app/participant-cash-transfer-service/cash-transfer-status',
          labelField: 'name',
          valueField: 'id',
        },
      },
    ],
  },

  columns: [
    {
      field: 'requestDate',
      header: 'Request Date',
      type: 'date',
      sortable: false,
      width: 140,
    },
    {
      field: 'amountString',
      header: 'Amount',
      type: 'currency',
      sortable: false,
      width: 150,
      align: 'center',
    },
    {
      field: 'cancelRequestedDate',
      header: 'Cancel Requested',
      type: 'date',
      sortable: false,
      width: 160,
      align: 'center',
    },
    {
      field: 'status',
      header: 'Transfer Status',
      type: 'badge',
      sortable: false,
      width: 160,
      align: 'center',
      badge: {
        statusMap: {
          'Pending Broker': 'info',
          'Broker Received': 'info',
          Failed: 'error',
          Transferred: 'success',
          Cancelled: 'error',
        },
        defaultVariant: 'info',
      },
    },
    {
      field: 'methodType',
      header: 'Method',
      sortable: false,
      width: 120,
      align: 'center',
    },
  ],

  actions: {
    row: [{ id: 'VIEW_DETAILS_CASH_TRANSFER_DASHBOARD', label: 'View Details' }],
  },

  features: {
    search: { enabled: false },
    pagination: { mode: 'none' },
    filterGrid: { columns: 2 },
    groupBy: {
      fields: ['requestDate'],
      expandMode: 'expanded',
      hideGroupedColumn: false,
      groupHeader: { showCount: true },
    },
  },
};
